/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import { useRootStore } from 'src/new_arch/providers/RootStoreProvider';

import { getAssetSortingForNewArch } from '../../../../selectors/assetsFilterAndSortOptions';

import { type AssetsViewParams } from '../types';
import { getIntegerParamFrom, getProjectIDFrom } from './utils';
import useFilterStore from './useFilterStore';

const useAssetsViewParams = (): AssetsViewParams => {
	const pathParams = useParams();
	const projectID = getProjectIDFrom( pathParams );
	const folderID = getIntegerParamFrom( pathParams, 'folderID' ) || null;

	const { filters } = useFilterStore( projectID );
	// TODO: do not get filters and sorts from Redux store. They should be stored
	// elsewhere once the whole project view is refactored.
	// @ts-ignore
	const sorting = useSelector( state => getAssetSortingForNewArch( state, { projectID } ) );

	const { assetsFlatViewEnabled: flatView } = useRootStore();

	return { projectID, folderID, filters, sorting, flatView };
}

export default useAssetsViewParams;
